// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanUpdateSecurityModel } from "./hook";

export type CanUpdateSecurityModelProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanUpdateSecurityModel({
  children,
  fallback,
  scope,
}: CanUpdateSecurityModelProps) {
  const canDoAction = useCanUpdateSecurityModel(scope);
  return <>{canDoAction ? children : fallback}</>;
}
